<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center" :key="key">
      <img alt="graphic-404" class="mx-auto mb-4 max-w-full" src="@/assets/images/pages/404.png">

      <template v-if="inProgress">
      <h1 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color">{{ $t('common.maintenance.in_progress.title') }}</h1>
      <p class="text-2xl sm:mx-0 mx-4 " v-for="(message,index) in $t('common.maintenance.in_progress.message')" v-html="message" :key="index"></p>
      <p class="text-2xl sm:mx-0 mx-4   text-italic" v-if="remaining">{{ $t('common.maintenance.in_progress.estimation', {remaining}) }}</p>
      <p class="text-2xl sm:mx-0 mx-4   text-italic" v-if="!remaining">{{ $t('common.maintenance.in_progress.unknown_estimation') }}</p>
      </template>
      <template v-else>
      <template v-if="isScheduled">
      <h1 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color">{{ $t('common.maintenance.scheduled.title') }}</h1>
      <p class="text-2xl sm:mx-0 mx-4 " v-for="(message,index) in $t('common.maintenance.scheduled.message')" v-html="message" :key="index"></p>
      <p class="text-2xl sm:mx-0 mx-4   text-italic" v-if="remainingBeforeMaintenance"> {{ $t('common.maintenance.scheduled.estimation',{remainingBeforeMaintenance}) }}</p>
      <vs-button class="mt-4" size="large" @click.native="goToApp">Back to Starling HQ</vs-button>
      </template>
      <template v-else>
      <h1 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color">{{ $t('common.maintenance.done.title') }}</h1>
      <p class="text-2xl sm:mx-0 mx-4 " v-for="(message,index) in $t('common.maintenance.done.message')" v-html="message" :key="index"></p>
      <vs-button class="mt-4" size="large" @click.native="goToApp">Back to Starling HQ</vs-button>
      </template>
      </template>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default {

  data () {
    return {
      now: this.$moment(),
      key: 0,
      interval: null,
      polling: null,
      pingOK: false
    };
  },
  computed: {
    maintenance () {
      return this.$store.state.maintenance.maintenance;
    },
    inProgress () {
      if (!this.now) return true;
      if (!this.pingOK) return true;
      if (this.now && this.maintenance && this.now.isAfter(this.$moment(this.maintenance.start))) return true;
      return false;
    },
    isScheduled () {
      if (this.maintenance && this.now.isBefore(this.$moment(this.maintenance.start))) return true;
      return false;
    },
    remaining () {
      if (!this.maintenance) return null;
      const end = this.$moment(this.maintenance.start).add(this.maintenance.duration);
      if (end.isBefore(this.now)) {
        return this.$t('common.maintenance.in_progress.over_estimated');
      }
      return Vue.filter('durationFormat')(end.diff(this.now));
    },
    remainingBeforeMaintenance () {
      if (!this.maintenance) return null;
      const end = this.$moment(this.maintenance.start);
      return Vue.filter('durationFormat')(end.diff(this.now));
    }
  },
  created () {
    this.interval = setInterval(() => {
      this.now = this.$moment();
      this.$forceUpdate();
      this.key++;

      if (this.maintenance && this.now.isSame(this.maintenance, 'second')) {
        this.ping();
      }
    }, 1000);

    this.polling = setInterval(() => {
      this.ping();
    }, 60000);
    this.ping();
  },
  destroyed () {
    clearInterval(this.interval);
    clearInterval(this.polling);
  },
  methods: {
    goToApp () {
      window.location.pathname = '/';
    },
    ping () {
      this.$store.dispatch('maintenance/ping').then(res => {
        this.pingOK = res.status === 204;
      });
    }
  }
}
;</script>
